import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyDGZ8bOAtZJySx1XBm1GnpydlUWLuMxaz4",
    authDomain: "mechanic-99e0c.firebaseapp.com",
    projectId: "mechanic-99e0c",
    storageBucket: "mechanic-99e0c.firebasestorage.app",
    messagingSenderId: "768579831455",
    appId: "1:768579831455:web:f9b7a48e6229c96b2644aa",
    measurementId: "G-4Q007KGV03"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
